import React from "react";
import { CompatThemeProvider } from "../compatThemeProvider";

export function withCompatTheme<T extends React.ElementType>(Component: T): React.FC {
    function ResultComponent(props: Record<string, unknown>) {
        return (
            <CompatThemeProvider>
                <Component {...props as any} />
            </CompatThemeProvider>
        );
    }

    return ResultComponent;
}
